import { ExpertiseStatus } from './service/expertiseService.model';
import { EmployeeExpertise } from './service/expertiseService.types';

export const getConfirmationChipTooltip = (expertise: EmployeeExpertise, date: string): string => {
  const confirmed = expertise.status === ExpertiseStatus.CONFIRMED;

  return confirmed ? `Confirmed by ${expertise.confirmedByAlias} ${date}` : `Created ${date}`;
};
